import { Component } from '@angular/core';
import { ModalController, NavParams } from 'ionic-angular';

import { ContratosGestaoService } from '../../../../providers/contratos-gestao-service';
import { MenuService } from '../../../../providers/menu-service';

import { ModulosController } from '../../modulos-controller';
import { UsuarioService } from '../../../../providers/usuario-service';
import { GestaoPcaService } from '../../../../providers/gestao-pca-service';
import { AlertService } from '../../../../providers/alert-service';
import { ModalNaoSeAplicaPage } from "../../../modais/nao-se-aplica/modal-nao-se-aplica";

import { ModalPreVisualizarContratosGestaoPage } from '../../../modais/modal-pre-visualizacao/contratos-gestao/modal-pv-contratos-gestao';

@Component({
  selector: 'page-resumo-acoes',
  templateUrl: 'resumo-acoes.html',
  providers: [
    ContratosGestaoService
  ]
})
export class ContratosGestaoResumoAnalisePage extends ModulosController {
  listaAnalises: any[];
  listaContratos: any[];
  loading: boolean = true;
  // isJurisdicionado: boolean;
  usuario: any;

  constructor(private contratosGestaoService: ContratosGestaoService,
    public alertService: AlertService, public usuarioService: UsuarioService,
    public modalCtrl: ModalController, public navParams: NavParams,
    public gestaoPcaService: GestaoPcaService, public menuService: MenuService) {
    super(modalCtrl, navParams, alertService, usuarioService, gestaoPcaService);
    this.carregarDados();
    this.setModuloId(14);

  }

  carregarDados() {
    if (!this.isJurisdicionado) {
      this.contratosGestaoService.obterListaAnalises().subscribe(data => {
        this.listaAnalises = data;

        this.listaAnalises.forEach(x => {
          if (x.idStatusAnalise == 5 || x.idStatusAnalise == 6 || x.idStatusAnalise == 7) {
            x.idStatusAnalise = 11;
            x.dsStatusAnalise = 'Para Consulta';
          }
        });

        this.loading = false;
      }, error => {
        console.log("erro: " + error);
        this.loading = false;
      });
    } else {
      this.contratosGestaoService.obterListaAnalisesJur(this.contratosGestaoService.codigoModuloContratosGestao).subscribe(data => {
        this.listaAnalises = data;

        this.loading = false;
      }, error => {
        console.log("erro: " + error);
        this.loading = false;
      });

      this.contratosGestaoService.obterContratosGestao().subscribe(data => {
        this.listaContratos = data;
        this.loading = false;
      }, error => {
        console.log("erro: " + error);
        this.loading = false;
      });
    }
  }

  redirecionarParaAnalise(analise) {
    console.log("Inicio Redirecionamento");
    if (!this.isJurisdicionado || analise.cdAnalise == '141' || analise.cdAnalise == '140' || (this.listaContratos != undefined && this.listaContratos.length > 0)) {

      analise.cdModulo = this.contratosGestaoService.obterIdPaginaContratosGestao();
      console.log(analise.cdAnalise);
      this.menuService.redirecionarSubPagina(this.contratosGestaoService.obterIdPaginaContratosGestao(), analise);

    } else {
      this.alertService.mostraAlerta("", "Necessário cadastrar pelo menos um Contrato de Gestão no item 'Cadastro de Contratos de Gestão'.");
    }

  }

  voltarPCA() {
    let idSecaoPaginaGestaoPCA = '964';

    this.menuService.redirecionarPagina(idSecaoPaginaGestaoPCA);
  }

  naoSeAplica(item) {

    this.gestaoPcaService.obterModuloPcaPorPCAPorModulo(this.gestaoPcaService.getPCA().id, 14).subscribe(data => {

      let titulo = "NÃO SE APLICA";
      let modal = this.modalCtrl.create(ModalNaoSeAplicaPage,
        {
          titulo: titulo,
          moduloPca: data,
          IdProcesso: data.moduloPca,
          tipoAnalise: 0,
          jurisdicionado: this.isJurisdicionado,
          isCGE: this.isCGE,
          origemArquivo: "NA",
          origemFilter: 'CONTRATO GESTAO',
          tipoEntidadeExercicio: 0,
          tipoDocumento: 0
        });
      modal.onDidDismiss(retornoModal => {
        this.carregarDados();
        if (retornoModal && retornoModal.flag) {
        }
      });

      modal.present();

    }, error => {
      console.log("erro ao carregar modulo pca: " + error);
    });

  }

  naoSeAplicaAnalise(item) {

    this.gestaoPcaService.obterModuloAnalise(item.idModuloAnalise).subscribe(data => {

      let titulo = "NÃO SE APLICA";
      let modal = this.modalCtrl.create(ModalNaoSeAplicaPage,
        {
          titulo: titulo,
          moduloAnalise: data,
          IdProcesso: data.moduloAnalise,
          tipoAnalise: 0,
          jurisdicionado: this.isJurisdicionado,
          isCGE: this.isCGE,
          origemArquivo: "NA",
          origemFilter: 'CONTRATO GESTAO',
          tipoEntidadeExercicio: 0,
          tipoDocumento: 0
        });
      modal.onDidDismiss(retornoModal => {
        this.carregarDados();
        if (retornoModal && retornoModal.flag) {
        }
      });

      modal.present();



    }, error => {
      console.log("erro ao carregar modulo pca: " + error);
    });

  }

  previsualizarCertificado() {

    let modal = this.modalCtrl.create(ModalPreVisualizarContratosGestaoPage, {});
    modal.onDidDismiss(retornoModal => {
      //retorno da modal
    });
    modal.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/modulos/contratos-gestao/resumo-acoes/resumo-acoes.ts